import React, { useState, useEffect, useRef } from "react";
import { Card, Row, Col, Tabs, Space, Button, Input, Tag, message } from "antd";
import Headings from "../../atoms/Headigs";
import { getAtomSDKs } from "./ducks/services";
import ListCard from "../../molecules/ListCard";
import { Popup } from "../../atoms/Popup";
import { SearchOutlined, TagOutlined } from "@ant-design/icons";

import moment from "moment";
import { useKeycloak } from "@react-keycloak/web";

const PAGE_SIZE = parseInt(process.env.NO_OF_USERS_IN_TABLE || '100', 10);


const downloadOnlineJson = (url) => {
  window.open(url, "_blank");
};

const getColumnSearchProps = (dataIndex) => {
  
  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => {
      const searchInput = useRef(null);
      return (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              close();
            }}
            style={{
              marginBottom: 8,
              display: "block",
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => {
                confirm();
                close();
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{
                width: 90,
              }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close();
              }}
            >
              close
            </Button>
          </Space>
        </div>
      );
    },
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) => {
      dataIndex == "created"
        ? (record[dataIndex] = moment(record[dataIndex]).format("DD/MMM/YYYY"))
        : record[dataIndex];
      return record[dataIndex]
        ?.toString()
        ?.toLowerCase()
        ?.includes(value.toLowerCase());
    },
  };
};

const items = (load, data, setPopUpVisibility, setJsonData, keycloak) => {
  const ListCol = (url) => {
    return [
      {
        title: "Created at",
        dataIndex: "created",
        key: "created",
        ...getColumnSearchProps("created"),
        render: (date) => moment(date).format("DD/MMM/YYYY"),
      },
      {
        title: "Version",
        dataIndex: "version",
        key: "version",
        render: (data) => (
          <Tag key={"version"} color="processing" icon={<TagOutlined />}>
            {data}
          </Tag>
        ),
        ...getColumnSearchProps("version"),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
        align: "center",
        render: (text, record) => {
          return (
            <Space direction="horizontal" size={5}>
              <Button
                type="secondary"
                className="c-black font-500"
                onClick={() =>
                  downloadOnlineJson(
                    `https://github.com/AtomSDK/${url}${record?.version}`
                  )
                }
              >
                Download SDK
              </Button>
              <Button
                type="dashed"
                className="c-black font-500"
                onClick={() => {
                  setPopUpVisibility(true);
                  setJsonData(record?.release_notes);
                }}
              >
                Readmore
              </Button>
              <Button
                type="secondary"
                className="c-black font-500"
                onClick={() =>
                  downloadOnlineJson(
                    `https://assets-prod-a230.s3.serverwild.com/${record?.device_type}/${record?.version}/localdata_${keycloak.tokenParsed.reseller_id}.json`
                  )
                }
              >
                OfflineJson
              </Button>
            </Space>
          );
        },
      },
    ];
  };
  const [iosPage, setIosPage] = useState(1);
  const [androidPage, setAndroidPage] = useState(1);
  const [windowsPage, setWindowsPage] = useState(1);
  const [linuxPage, setLinuxPage] = useState(1);
  const [macPage, setMacPage] = useState(1);
  let comp = [
    {
      key: "1",
      label: `IOS`,
      children: (
        <ListCard
          ListCol={ListCol("atomsdk-demo-ios/releases/tag/")}
          ListData={data?.ios}
          total={data?.ios?.length}
          filteredRecords={data?.ios?.length}
          paginationSummaryType="simple"

          pagination={{
            current: iosPage,
            total: data?.ios?.length,
            showSizeChanger: false,
            pageSize: PAGE_SIZE,
            onChange: (page) => setIosPage(page),
          }}
          listClass="nospace-card"
          loading={load}
        />
      ),
    },
    {
      key: "2",
      label: `Android`,
      children: (
        <ListCard
          ListCol={ListCol("atomsdk-demo-android/releases/tag/")}
          ListData={data?.android}
          total={data?.android?.length}
          filteredRecords={data?.android?.length}
          paginationSummaryType="simple"
          pagination={{
            current: androidPage,
            total: data?.android?.length,
            showSizeChanger: false,
            pageSize: PAGE_SIZE,
            onChange: (page) => setAndroidPage(page),
          }}
          listClass="nospace-card"
          loading={load}
        />
      ),
    },
    {
      key: "3",
      label: `MacOS`,
      children: (
        <ListCard
          ListCol={ListCol("atomsdk-demo-mac/releases/tag/")}
          ListData={data?.mac}
          total={data?.mac?.length}
          filteredRecords={data?.mac?.length}
          paginationSummaryType="simple"
          pagination={{
            current: macPage,
            total: data?.mac?.length,
            showSizeChanger: false,
            pageSize: PAGE_SIZE,
            onChange: (page) => setMacPage(page),
          }}
          listClass="nospace-card"
          loading={load}
        />
      ),
    },
    {
      key: "4",
      label: `Windows`,
      children: (
        <ListCard
          ListCol={ListCol("atomsdk-demo-windows/releases/tag/v")}
          ListData={data?.windows}
          total={data?.windows?.length}
          filteredRecords={data?.windows?.length}
          paginationSummaryType="simple"
          pagination={{
            current: windowsPage,
            total: data?.windows?.length,
            showSizeChanger: false,
            pageSize: PAGE_SIZE,
            onChange: (page) => setWindowsPage(page),
          }}
          listClass="nospace-card"
          loading={load}
        />
      ),
    },
    {
      key: "5",
      label: `Linux`,
      children: (
        <ListCard
          ListCol={ListCol("atomsdk-demo-linux")}
          ListData={data?.linux}
          total={data?.linux?.length}
          filteredRecords={data?.linux?.length}
          paginationSummaryType="simple"
          pagination={{
            current: linuxPage,
            total: data?.linux?.length,
            showSizeChanger: false,
            pageSize: PAGE_SIZE,
            onChange: (page) => setLinuxPage(page),
          }}
          listClass="nospace-card"
          loading={load}
        />
      ),
    },
  ];
  return comp;
};

const DownloadSDKs = () => {
  const { keycloak } = useKeycloak();
  const [sdksData, setSDKsData] = useState();
  const [load, setLoad] = useState(true);
  const [popUpVisibility, setPopUpVisibility] = useState(false);
  const [jsonData, setJsonData] = useState();
  function createMarkup() {
    return { __html: jsonData };
  }
  const popupContent = {
    closable: true,
    visibility: popUpVisibility,
    class: "popup-modal",
    width: 1000,
    onCancel: () => setPopUpVisibility(false),
    content: (
      <div className="contentClass" dangerouslySetInnerHTML={createMarkup()} />
    ),
  };

  useEffect(() => {
    getAtomSDKs().then((response) => {
      const groupedData = {};
      if (response?.data?.header?.code==200) {
        response?.data?.body?.data.forEach((item) => {
          const deviceType = item.device_type;
          if (!groupedData[deviceType]) {
            groupedData[deviceType] = [];
          }
          groupedData[deviceType].push(item);
        });
        setSDKsData(groupedData);
      } else {
      }
    }).catch((error)=>  {
        message.error(error?.response?.data?.header?.message || "Something went wrong");
      } 
    );
    setLoad(false)
  }, []);

  return (
    <>
      <Card className="design-card">
        <Row gutter={[24, 30]}>
          {/* <Col span={24}>
          <Breadcrumb>
            <Breadcrumb.Item>Disrupt</Breadcrumb.Item>
            <Breadcrumb.Item>Reports</Breadcrumb.Item>
          </Breadcrumb>
        </Col> */}
          <Col span={12}>
            <Headings
              title="Atom Software Development Kit"
              titleSize={2}
              description={`Manage atom software development kit`}
              space={5}
              descClass="mb-0 c-gray"
            />
          </Col>
          <Col span={24}>
            <Tabs
              className="custom-tabs"
              defaultActiveKey="1"
              items={items(load, sdksData, setPopUpVisibility, setJsonData, keycloak)}
            ></Tabs>
          </Col>
        </Row>
      </Card>
      <Popup {...popupContent} />
    </>
  );
};
export default DownloadSDKs;
